const config = {
  API_BASE_URL: "/api",
  ORIGIN: window.location.origin,
  SENTRY_DSN: "https://56224e44e8064a2ab36a33716d6e3451@o118529.ingest.sentry.io/5521769",
  STRIPE_API_KEY: "pk_test_51Ht9RUEaUrzegpW3Pn1huv6WZzw7UhqUpg0owWq4kEe5RId7s5CrBWaqLZlJ5FN6DkkBpDjvtdCHk4yG1dX68gcv00VKAbNxX9"
};

export default config;